import { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { listBranches } from "../../api/directory";
import { resolveSystem } from "../../lib/calendar";
import { setActiveCalendar } from "../../lib/format";

// يضبط نظام التقويم الفعّال في التطبيق وفق فرع المستخدم الحالي (أو المركز الرئيسي كبديل).
export const CalendarSync = () => {
  const { user } = useAuth();
  useEffect(() => {
    if (!user) return;
    let alive = true;
    listBranches()
      .then((list) => {
        if (!alive) return;
        const mine = (user.branch_ids || [])[0];
        const branch = list.find((b) => b.id === mine) || list.find((b) => b.is_head_office) || list[0];
        setActiveCalendar(resolveSystem(branch?.calendar_system, branch?.timezone_name));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [user]);
  return null;
};
